import { DatePipe } from '@angular/common';
import { BytesToSizePipe } from '../../filters/bytes-to-size.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import {Component, OnInit, OnDestroy, inject, HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ModalService from '../../services/modal.service';
import ImageService from '../../services/image.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input } from '@angular/core';
import { ModalMediaComponent } from '../../components/modal-media/modal-media.component';
import { Subscription } from 'rxjs';
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import ChatRestServices from "../../services/chat-rest.service";
import DialogServices from "../../services/dialog.service";

@Component({
	standalone: true,
	selector: 'item-message-media',
	templateUrl: './item-message-media.component.html',
	imports: [CommonModule, ModalMediaComponent, DatePipe, BytesToSizePipe, TranslatePipe, LoaderOverlayComponent, FormsModule]
})
export class ItemMessageMediaComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private modalService: ModalService = inject(ModalService);
	private imageService: ImageService = inject(ImageService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private dialogServices: DialogServices = inject(DialogServices);

	@Input() lastSeen: any | undefined;
	@Input() chat: any;
	@Input() group: any;

	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	activeMessage: any | null = null;
	isDesktop = window.innerWidth >= 768;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.media = this.vm.group.messages[0];
		this.vm.uid = 'imi-' + this.vm.media.id;

		var currentIsUploaded = undefined;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.media.isUploaded !== currentIsUploaded) {
				currentIsUploaded = this.vm.media.isUploaded;
				this.onMediaUpload(this.vm.media.isUploaded);
			}
		}, 300);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Modal.MEDIA_CLOSING,
				(e, data) => { this.handleMediaClose(e, data); })
		);

		this.vm.handleMediaOpen = this.handleMediaOpen;
		this.vm.onMouseLeave = this.onMouseLeave;
		this.vm.onMouseEnter = this.onMouseEnter;
		this.vm.deleteMessage = this.deleteMessage;
		this.vm.toggleActions = this.toggleActions;

	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	onMediaUpload(isUploaded) {
		if (!isUploaded) return;
		this.vm.media.isPreloading = true;
		if (this.vm.media.postType === 'DOCUMENT') {
			this.vm.media.isPreloaded = true;
			this.vm.media.isPreloading = false;
		} else {
			this.imageService.preloadImage(this.vm.media.thumbnailUrl)
				.then(() => {
					this.vm.media.isPreloaded = true;
					this.vm.media.isPreloading = false;
				});
		}
	}

	handleMediaClose(e, data) {
		if (data.id === this.vm.uid) this.vm.mediaOpen = false;
	}

	handleMediaOpen() {
		if (!this.vm.media.fileUrl || this.modalService.get(this.vm.uid)) return;
		var loader: any = this.angularHelperService.createTimer(
			() => { this.vm.loading = true; }, this.config.getOtherConfig().LOADER_TIMEOUT_INIT
		);

		if (this.vm.media.postType === 'VIDEO') {
			this.openMedia(loader);
		} else {
			this.imageService.preloadImage(this.vm.media.fileUrl)
				.then(() => {
					this.openMedia(loader);
				});
		}
	}

	openMedia(loader) {
		this.vm.mediaOpen = true;
		if (this.vm.loading) {
			this.angularHelperService.createTimer(
				() => {
					this.vm.loading = false;
					this.modalService.openMedia(
						ModalMediaComponent,
						{ media: this.vm.media, chat: this.vm.chat.id, modalId: this.vm.uid }
					);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		} else {
			this.angularHelperService.cancelTimer(loader);
			this.modalService.openMedia(
				ModalMediaComponent,
				{ media: this.vm.media, chat: this.vm.chat.id, modalId: this.vm.uid }
			);
		}
	}

	onMouseEnter(message: any) {
		if (this.isDesktop) {
			message.showDots = true;
		}
	}

	onMouseLeave(message: any) {
		if (this.isDesktop) {
			message.showDots = false;
		}
	}

	toggleActions(message: any, event: Event, container: HTMLElement) {
		event.stopPropagation();
		message.showActions = !message.showActions;

		message.showDots = true;

		this.activeMessage = message.showActions ? { message, container } : null;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.activeMessage) return;

		const target = event.target as HTMLElement;
		const { message, container } = this.activeMessage;

		if (message.showActions && container && !container.contains(target)) {
			message.showActions = false;
			if (this.isDesktop) message.showDots = false;
			this.activeMessage = null;
		}
	}


	deleteMessage(message: any) {
		this.handleDeleteMessage(message);
	}

	handleDeleteMessage(textMessage: any) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Modal.Content.Delete_Message_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.vm.loading = true;
				var chat: any = this.angularHelperService.copy(this.vm.chat);
				var message: any = {
					id: textMessage.id,
					content: this.angularFilterHelperService.translate('Chats.Other.Deleted'),
					chat: {
						id: this.vm.chat.id
					}
				};
				this.chatRestServices.updateChatMessage(
					{ forUser: this.vm.chat.privateChatFriend.id, isDeleted: true }, message,
					(res) => {
						this.vm.loading = false;
						this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CHAT_POST_DELETED, [res], chat.id);
					},
					(err) => {
						console.error(err);
						this.vm.loading = false;
					}
				);
			}
		});
	}

}